function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 0.5C5.42578 0.5 0.5 5.42578 0.5 11.5C0.5 17.5742 5.42578 22.5 11.5 22.5C17.5742 22.5 22.5 17.5742 22.5 11.5C22.5 9 21.6719 6.69141 20.2656 4.84375L11.0469 15.7188L6.20312 11.2188L6.89062 10.4844L10.9531 14.2812L19.6094 4.0625C17.5977 1.86914 14.7109 0.5 11.5 0.5ZM19.6094 4.0625C19.8379 4.3125 20.0605 4.57422 20.2656 4.84375L21.375 3.51562L20.625 2.875L19.6094 4.0625Z",
  fill: "#008000"
});

var SvgValidated = function SvgValidated(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValidated, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Validated.9e12d7cb.svg";
export { ForwardRef as ReactComponent };